import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

// Chrome's translator (page was lang="en") and some extensions reparent text
// nodes. React then throws NotFoundError on removeChild and the screen goes
// blank. Skip the move when the node is no longer where React expects it.
function tolerateExternalDomMoves() {
  if (typeof Node !== 'function' || Node.prototype.__erpDomHardened) return
  const removeChild = Node.prototype.removeChild
  Node.prototype.removeChild = function (child) {
    if (child && child.parentNode !== this) return child
    return removeChild.call(this, child)
  }
  const insertBefore = Node.prototype.insertBefore
  Node.prototype.insertBefore = function (newNode, ref) {
    if (ref && ref.parentNode !== this) return this.appendChild(newNode)
    return insertBefore.call(this, newNode, ref)
  }
  Node.prototype.__erpDomHardened = true
}

tolerateExternalDomMoves()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
